import { createFileRoute } from '@tanstack/react-router';
import { WalletPage } from '../features/parent/WalletPage';
import { RequireAuth } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/parent/wallet')({
  component: () => <RequireAuth role="parent">{(me) => <WalletPage me={me} />}</RequireAuth>,
});
